module.exports = __webpack_public_path__ + "assets/font/SourceHanSansTWHK-Normal-dddb63e9.otf";